export const apiConstants = {
//API_URL: 'http://localhost:4834/api'
 API_URL: 'https://office.dadpezeshk.ir:4443/api'
};
